import React, { useState } from 'react'
import styles from './SearchableCardMulti.scss'
import { PopoverMenu, PopoverMenuItem } from 'common/styleguide/PopoverMenu'
import { RadioGroup } from 'common/styleguide/RadioGroup'
import { Icon } from 'common/Icon'
import { useFormatMessage, searchResultsText } from 'lib/localization'
import { FormattedMessage as T, defineMessages } from 'react-intl'

const messages = defineMessages({
  location: {
    id: 'SearchableCardMulti.location',
    defaultMessage: 'Location'
  },
  currentLocation: {
    id: 'SearchableCardMulti.currentLocation',
    defaultMessage: 'Current Location'
  },
  locating: {
    id: 'SearchableCardMulti.locating',
    defaultMessage: 'Locating'
  }
})

export const SearchableCardMulti = ({ inputs, chips, resultsCount, resultsLength, children }) => (
  <>
    <div className={styles.searchContainer}>
      <div className={styles.inputs}>
        {inputs}
      </div>
      {chips && <div className={styles.chips}>
        {chips}
      </div>}
      {resultsCount !== undefined && <div className={styles.resultsCount}>
        {searchResultsText(resultsLength, resultsCount)}
      </div>}
    </div>
    <div className={styles.resultsContainer}>
      {children}
    </div>
  </>
)

export const SearchableCardInput = ({ placeholder, spellCheck, type, keywords, onKeywordChange }) => (
  <div className={styles.searchInputContainer}>
    <input
      placeholder={placeholder}
      spellCheck={spellCheck || 'false'}
      type={type || 'text'}
      className={styles.searchInput}
      value={keywords}
      onChange={onKeywordChange} />
  </div>
)

export class SearchableCardLocationInput extends React.PureComponent {
  static defaultProps = {
    radiusControl: true,
    geolocationControl: false
  }

  constructor (props) {
    super(props)

    this.state = {
      showRadius: false
    }
  }

  toggleRadius = () => { this.setState({ showRadius: !this.state.showRadius }) }

  render () {
    const {
      placeholder,
      keywords,
      onKeywordChange,
      radius,
      radiusMenuOpts,
      onRadiusChange,
      radiusControl
    } = this.props
    const { showRadius } = this.state

    return (
      <div className={styles.compositeLocationSearch}>
        <input
          placeholder={placeholder}
          spellCheck='false'
          type='text'
          className={styles.locationSearchInput}
          value={keywords}
          onChange={onKeywordChange} />
        {radiusControl && <button ref={r => { this._button = r }}
          onClick={this.toggleRadius}
          className={styles.radiusButton}>
          <T id='SearchableCardMulti.within'
            defaultMessage='within {r}'
            values={{ r: <span>{radiusMenuOpts.get(radius)}</span> }} />
        </button>}
        {radiusControl && showRadius && <PopoverMenu
          target={this._button}
          placement='bottom'
          onRequestClose={() => this.toggleRadius()}>
          <PopoverMenuItem>
            <RadioGroup
              style={{ margin: '0 0' }}
              horizontal
              options={radiusMenuOpts}
              selected={radius}
              onChange={onRadiusChange} />
          </PopoverMenuItem>
        </PopoverMenu>}
      </div>
    )
  }
}

// location input that flips between a `location` string and a `lat/lng` pairing
export const HybridBrowserLocationInput = ({ location, lng, lat, onLocationInputChange }) => {
  const [locatePending, setLocatePending] = useState(false)
  const fm = useFormatMessage()

  const onKeywordChange = (e) => {
    const location = e.target.value
    onLocationInputChange({ lat: null, lng: null, location })
  }

  const queryLocationFromBrowser = () => {
    if ('geolocation' in navigator) {
      onLocationInputChange({ location: '', lng, lat })
      setLocatePending(true)
      navigator.geolocation.getCurrentPosition(position => {
        const lng = position.coords.longitude
        const lat = position.coords.latitude
        setLocatePending(false)
        onLocationInputChange({ location: '', lng, lat })
      })
    }
  }

  const placeholder = fm(lat ? messages.currentLocation : messages.location)

  return (
    <div className={styles.compositeLocationSearch}>
      <input
        placeholder={locatePending ? `${fm(messages.locating)}...` : placeholder}
        spellCheck='false'
        type='text'
        className={styles.locationSearchInput}
        value={location}
        onChange={onKeywordChange} />
      <button
        onClick={queryLocationFromBrowser}
        className={styles.locateButton}>
        <Icon i='ios-locate-outline' size={22} />
      </button>
    </div>
  )
}
